module.exports = __webpack_public_path__ + "img/25.3b49370b.png";